module.exports = __webpack_public_path__ + "media/new/residential-64-40347b57.png";